import { useCallback, useEffect, useState } from "react";
import {
  getOdooLiveChatFirstName,
  leaveOdooLiveChatMessage
} from "services/odoo-live-chat/odoo-live-chat";

import {
  IUseOdooLiveChatLeaveMessage,
  LeaveMessageMode
} from "./use-odoo-live-chat-leave-message.types";

const ERROR_TEXT: Record<string, string> = {
  rate_limited: "Kamu udah kirim beberapa pesan. Coba lagi nanti, ya.",
  failed: "Pesan belum terkirim. Coba lagi, ya."
};

// State of the closed panel: the visitor's first name for the "[Nama]"
// placeholder in the configured messages, and the "leave a message" form.
export const useOdooLiveChatLeaveMessage = (): IUseOdooLiveChatLeaveMessage => {
  const [firstName, setFirstName] = useState("");
  const [mode, setMode] = useState<LeaveMessageMode>("info");
  const [text, setText] = useState("");
  const [isSending, setIsSending] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    getOdooLiveChatFirstName().then(setFirstName);
  }, []);

  const personalize = useCallback(
    (message: string) =>
      firstName
        ? message.replaceAll("[Nama]", firstName)
        : message.replace(/,?\s*\[Nama\]/g, ""),
    [firstName]
  );

  const send = useCallback(async () => {
    const message = text.trim();
    if (!message || isSending) return;
    setIsSending(true);
    setError("");
    const result = await leaveOdooLiveChatMessage(message);
    setIsSending(false);
    if (result === "ok") {
      setMode("sent");
      setText("");
    } else {
      setError(ERROR_TEXT[result]);
    }
  }, [text, isSending]);

  return { mode, setMode, text, setText, isSending, error, personalize, send };
};
